import React from "react";
import SharedFormPage from "./shared-form-page";

const RoomTemplateNewPage = props => <SharedFormPage mode="create" {...props} />;

export default RoomTemplateNewPage;
